



class MobileAppPageView extends Backbone.View {
    get el() {
        return 'body';
    };

    initialize() {
        let $navs = $('.app-nav');
        let currentUrl = this.getParameterByName('app');
        let $currentLink = $(`.app-nav[data-id=${currentUrl}]`);
        let $contentToDisplay = $(`.app-wrap[id=${currentUrl}]`);
        let left = $contentToDisplay.find('.left').get(0);
        let right = $contentToDisplay.find('.right').get(0);

        if (typeof window.is_mobile_site !== 'undefined' && window.is_mobile_site) {
            this.$el.removeClass('side-menu-active');
        }
        else {
            $navs.removeClass('selected');
            $currentLink.addClass('selected');
        }
        $('.app-wrap').addClass('closed');
        $($contentToDisplay).removeClass('closed');


        this.$el.find('.mobile-marketing').on('swipeleft', function() {
            if (right) {
                window.location.href = right
            }
        });
        this.$el.find('.mobile-marketing').on('swiperight', function() {
            if (left) {
                window.location.href = left
            }
        });
    };

    getParameterByName (name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);

        if (!results || !results[2]) {
            return 'evite-app';
        }

        return decodeURIComponent(results[2].replace(/\+/g, " "));
    };
}


$(document).ready(function() {
    new MobileAppPageView();
});



// WEBPACK FOOTER //
// ./assets/es6/marketing/mobile_apps.es6